import $ from 'jquery'

export default function()
{
	$('.hero_backdrops').each(function() {
		const $container = $(this)
		const $slides = $container.children();

		let $cur = $slides.first();

		setInterval(() => {
			$cur = $cur.next();

			if (!$cur.length) {
				$cur = $container.children().first();
				$cur.nextAll().fadeOut(800);
			}
			$cur.fadeIn(800);

		}, 6000);
	})
}



// WEBPACK FOOTER //
// ./public/scripts/src/initializers/hero.js